<template>
  <div>
    <h1>Error</h1>
    <h2>An error occurred while processing the request.</h2>
    <h3>{{message}}</h3>
  </div>
</template>

<script>
export default {
  name: 'error',
  computed: {
    message () {
      return this.$route.params.message
    }
  }
}
</script>